import * as util from '#packages/util';
import experiment from 'experiment';

import type { AppInstallOrigin } from '@wix/editor-platform-host-integration-apis';
import {
  EditorType,
  InstallationOriginType,
  InstallInitiator,
} from '@wix/platform-editor-sdk';
import * as stateManagement from '#packages/stateManagement';
import type { EditorAPI } from '#packages/editorAPI';
export const isAddSectionProductionMode =
  !experiment.isOpen('se_addDesignerSection') && !util.url.isQA();

export const isCreateSectionWithAIEnabled = (editorAPI: EditorAPI) => {
  const shouldEnableAIFeaturesInSchoolMode =
    stateManagement.schoolMode.selectors.shouldEnableAIFeatures(
      editorAPI.store.getState(),
    );
  return (
    experiment.isOpen('se_createSectionWithAI') &&
    shouldEnableAIFeaturesInSchoolMode
  );
};

export const origin = 'addSectionPanel';

export function getPanelCorrelationId(count: number): string {
  return `panelOpenCount_${count}`;
}

export function getAddSectionPlatformOrigin(): AppInstallOrigin {
  return {
    type: EditorType.Classic,
    initiator: InstallInitiator.Editor,
    info: {
      type: InstallationOriginType.ADD_SECTION_PANEL,
    },
  };
}

export const getLanguageConsiderFRLocalization = () =>
  util.editorModel.languageCode === 'fr' ? 'fr' : 'en';

export const getAddSectionPanelLanguage = () => {
  return getLanguageConsiderFRLocalization();
};
